// 利用規約用の変換データ
export default {
  data: () => ({
    i18n_mode: process.env.VUE_APP_LANG_MODE,
    // i18n_mode: 'jp',
    i18n_message: {
      ポイント利用規約: {
        en: 'Points Terms of Use',
      },
      '株式会社Iranoan（以下、「当社」といいます。）が提供するGacha24（以下、「本件サービス」といいます。）において「ポイント」（以下に定義します）を利用するにあたり、その利用に関する条件を定めるもの（以下、「ポイント利用規約」といいます。）です。': {
        en: 'Regarding the use of “points” (defined below) in Gacha24 (referred to as the “Service”) provided by Iranoan Co., Ltd. (referred to as the “Company”), Terms and conditions (referred to as "Points Terms of Use").',
      },
      '十分にポイント利用規約の内容をご確認いただいた上で、ポイントのご購入をご検討ください。': {
        en: 'Please consider purchasing points after thoroughly confirming the contents of the points terms and conditions.',
      },
      '第1条 - 用語の定義': {
        en: 'ARTICLE 1 - DEFINITION OF TERMS',
      },
      '本件規約における以下の各号の用語の意味は、当該各号に定めるとおりとします。': {
        en: 'The meanings of the terms in the following items in the Terms shall be as set forth in the respective items.',
      },
      '(1)「サービス利用契約」とは、本件サービスの利用に関する契約をいいます。': {
        en: '(1) "Service Agreement" means the agreement regarding the use of the Service.',
      },
      '(2)「サービス利用者」とは、当社とサービス利用契約を締結した者をいいます。': {
        en: '(2) "Service user" means a person who has entered into a service agreement with us.',
      },
      '(3)「アカウント情報」とは、サービス利用者が本件サービスに登録したサービス利用者に関する情報をいいます。': {
        en: '(3) "Account Information" means information about a Service User that a Service User has registered with the Service.',
      },
      '(4)「ポイント」とは、本件サービス内でのみ利用可能なゲーム内仮想通貨をいいます。': {
        en: '(4) “Points” means in-game virtual currency that can only be used within the Service.',
      },
      '(5)「利用残高」とは、サービス利用者が保有し、利用することのできるポイントの残高となります。': {
        en: '(5) “Use balance” means the balance of points that the service user possesses and can use.',
      },
      '第2条 - ポイント': {
        en: 'Article 2 - Points',
      },
      '(1)サービス利用者は、当社所定の方法により、当社が本件サービス内で提示している金額で本件サービス内で使用可能なポイントを購入することができます。なお、当社は、サービス利用者に対して、ポイントの購入について購入単位、決済方法、利用期間その他の購入条件を設けることがあり、設定した購入条件及び支払可能金額等は、本件サービス又は当社の運営するサービス内に掲載します。': {
        en: '(1) Service users can purchase points that can be used in the Service at the amount indicated in the Service by the Company in accordance with the method prescribed by the Company. In addition, the Company may set purchase units, payment methods, usage periods and other purchase conditions for the purchase of points for service users, and the set purchase conditions and payable amounts, etc. shall be subject to the Service or the Company. Posted in the service we operate.',
      },
      '(2)サービス利用者が当社所定の方法によりポイントの購入の意思表示を行った時点で、当該ポイントの購入に関するサービス利用者と当社の間の契約は成立し、購入にかかる総額が確定するものとします。': {
        en: '(2) At the time when the service user expresses their intention to purchase points in accordance with the method prescribed by the Company, the contract between the service user and the Company concerning the purchase of said points shall be concluded, and the total amount of purchase shall be determined. will do.',
      },
      '(3)ポイントを購入するサービス利用者が未成年者である場合、当該サービス利用者はポイントの購入についてあらかじめ親権者の同意を得なければなりません。': {
        en: '(3) If the service user who purchases points is a minor, the service user must obtain the consent of the person with parental authority in advance for the purchase of points.',
      },
      '(4)当社は未成年者がポイントを購入した場合、親権者が当該ポイントの購入に同意したものとみなします。': {
        en: '(4) If a minor purchases points, the Company will deem that the parent has consented to the purchase of the points.',
      },
      '(5)本件サービス内に表示されているサービス利用者の利用残高は、アカウント情報に紐づいて本件サービス及び当社の運営する他のサービスの提供にかかる電気通信設備に記録されます。': {
        en: '(5) The service user\'s usage balance displayed in the Service will be recorded in the telecommunications equipment related to the provision of the Service and other services operated by the Company, linked to account information.',
      },
      '第3条 - ポイントの利用': {
        en: 'Article 3 - Use of Points',
      },
      '(1)ポイントは、当社が本件サービス内の商品購入のために使用することができます。': {
        en: '(1) Points can be used by the Company to purchase products within the Service.',
      },
      '(2)サービス利用者は、ポイントの残高の範囲内で、当社が提供する商品を取得することができます。': {
        en: '(2) Service users can acquire products provided by the Company within the balance of points.',
      },
      '(3)サービス利用者が当社から商品を購入する際にポイントを使用した場合、ポイントの残高から商品の代金額を差し引くことにより、当該代金額の支払があったものとみなされます。なお、特段の定めがない場合、本件サービス内で当社からサービス利用者に対して無償で付与したポイントから優先的に消費されます。': {
        en: '(3) If a service user uses points to purchase a product from the Company, the amount will be deemed to have been paid by deducting the price of the product from the point balance. In addition, unless otherwise specified, the points given free of charge by the Company to the service user within the Service shall be preferentially consumed.',
      },
      '(4)サービス利用者は本件サービス内でポイントの残高を確認することができます。なお、サービス利用者はポイントの増減を自身の責任で管理し、確認するものとします。': {
        en: '(4) Service users can check the balance of points within the Service. In addition, service users shall manage and confirm the increase or decrease of points at their own responsibility.',
      },
      '第4条 - ポイントの取り扱い': {
        en: 'Article 4 - Handling of Points',
      },
      '(1)当社は、本サービスにおいて利用者がポイントを購入した場合、当社がキャンペーンを実施する場合その他の場合に、当社の定める方法により、利用者にポイントを付与します。ポイントの購入単位、価格、有効期間、その他のポイントの付与条件は、当社が定め、本サービス上に表示します。': {
        en: '(1) The Company shall grant points to the User in accordance with the method stipulated by the Company when the User purchases points in the Service, when the Company implements a campaign, or in other cases. The purchase unit, price, validity period, and other conditions for granting points shall be determined by the Company and displayed on the Service.',
      },
      '(2)ポイントの有効期間は、ポイントが付与された日から6か月とします。': {
        en: '(2) Points are valid for 6 months from the date they are awarded.',
      },
      '(3)当社は、利用者が取得したポイントについて、法令上必要な場合を除き、一切払い戻しを行いません。法令に基づきポイントを払い戻す場合の払戻方法および条件は、別途当社が定める方法で掲示するものとします。': {
        en: '(3) The Company shall not refund any points acquired by the User, except as required by law. The refund method and conditions for refunding points based on laws and regulations shall be posted in a manner separately determined by the Company.',
      },
      '第5条 - 換金行為の禁止等': {
        en: 'Article 5 - Prohibition of redemption, etc.',
      },
      '本サービス内で取得した一切のコンテンツについては、直接、第三者による仲介又はインターネットオークション等その手段を問わず、売買その他、金銭その他現実世界における対価を授受する形でのあらゆる譲渡、譲受、貸与、借用等する行為（いわゆるRMT【リアルマネートレード】を含みますが、これに限られません。また、本サービス内におけるユーザーの行為に対して金銭その他、現実世界における対価を授受することも含みます。）を禁止いたします。': {
        en: 'Regarding all content acquired in this service, regardless of the means such as mediation by a third party or Internet auction, any transfer, transfer, or lending in the form of giving and receiving money or other consideration in the real world , borrowing, etc. (including but not limited to so-called RMT [Real Money Trade]. In addition, including giving and receiving money or other consideration in the real world for the actions of users in this service. ) is prohibited.',
      },
      '第6条 - ポイントの譲渡等': {
        en: 'Article 6 - Transfer of Points, etc.',
      },
      'サービス利用者は、ポイント及び商品を第三者に譲渡、貸与、贈与その他の移転や、質入れその他の担保権の設定をすることはできません。': {
        en: 'Service users may not assign, lend, gift or otherwise transfer points and products to a third party, or set pledges or other security interests.',
      },
      '第7条 - ポイントの購入及び利用の停止等': {
        en: 'Article 7 - Suspension of purchasing and using points, etc.',
      },
      'サービス利用者が以下に該当する場合、当社はサービス利用者に対して、当社が適当と判断する措置（ポイントの購入や利用の停止を含むがこれに限りません。）を実施できるものとします。': {
        en: 'If the service user falls under any of the following, the Company may take measures that the Company deems appropriate (including, but not limited to, purchase of points or suspension of use). .',
      },
      '(1)不正な方法によりポイントや商品を取得、利用した場合': {
        en: '(1) Acquisition and use of points or products by illegal means;',
      },
      '(2)サービス利用者が本件規約に違反した場合': {
        en: '(2) When the service user violates the Terms',
      },
      '(3)その他、当社がサービス利用者の本件サービスの利用を不適切であると判断した場合': {
        en: '(3) In addition, when the Company determines that the use of the Service by the Service User is inappropriate.',
      },
      '2021年11月10日 制定': {
        en: 'Established November 10, 2021',
      },
    },
  }),
  methods: {
    t(code) {
      if (this.i18n_mode === 'jp') {
        return code;
      }
      if (this.i18n_message[code]) {
        if (this.i18n_message[code][this.i18n_mode]) {
          return this.i18n_message[code][this.i18n_mode];
        }
      }

      if (this.i18n_mode !== 'jp') {
        console.log(`紐づけなし:${code}`);
      }
      return code;
    },
  },
};
